import { NextImage, noForwardProps } from '@apeiron/temp'
import { Box, styled, Typography } from '@mui/material'
import Image from '@public/images/image-section-header-block.png'
import { SectionHeaderVariant } from '@src/constants/pageBuilder'
import { SectionHeaderBlock } from '@src/types/pageBuilder'

type Props = {
  title: string
  variant?: SectionHeaderBlock['variant']
}

const Container = styled(Box)`
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
`

const DecorationImage = styled(NextImage)`
  aspect-ratio: 294/36;
  height: 36px;

  ${({ theme }) => theme.breakpoints.down('res768')} {
    position: absolute;
  }
`

const Title = styled(Typography, noForwardProps)<{
  __fontSize: number
  __fontWeight: number
}>`
  color: #e9f8ff;
  font-size: ${({ __fontSize }) => __fontSize}px;
  font-weight: ${({ __fontWeight }) => __fontWeight};
  text-shadow: 0px 0px 2px #06f;
  text-align: center;

  ${({ theme }) => theme.breakpoints.down('res768')} {
    max-width: 250px;
  }
`

const LeftImage = styled(DecorationImage)`
  ${({ theme }) => theme.breakpoints.down('res768')} {
    position: absolute;
    transform: translate(-110%);
  }
`

const RightImage = styled(DecorationImage)`
  transform: scaleX(-1);

  ${({ theme }) => theme.breakpoints.down('res768')} {
    position: absolute;
    right: 0px;
    transform: translate(110%) scaleX(-1);
  }
`

const SectionHeaderBlockView = ({
  title,
  variant = SectionHeaderVariant.Default
}: Props) => {
  const fontSize = variant === SectionHeaderVariant.Large ? 48 : 32

  const fontWeight = variant === SectionHeaderVariant.Large ? 700 : 500

  return (
    <Container>
      <LeftImage src={Image.src} />
      <Title __fontSize={fontSize} __fontWeight={fontWeight}>
        {title}
      </Title>
      <RightImage src={Image.src} />
    </Container>
  )
}

export default SectionHeaderBlockView
